import React, { useState } from "react";
import { toast } from "react-toastify";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
// import JS files
import PanelTemplate from "../../../shares/PanelTemplate";
import PanelFilter from "../../../shares/PanelFilter";
import MuiPagination from "../../../shares/MuiPagination";
import PanelTable from "../../../shares/PanelTable";
import OrderDetails from "./OrderDetails";
import RemoveOrder from "./RemoveOrder";
import useFetch from "../../../../context/useFetch";
import { useUserData } from "../../../../context/UserDataContext";
import { EmptyData, fixNumbers } from "../../../../utils";
import PrintIcon from "@mui/icons-material/Print";
import MuiButton from "../../../shares/MuiButton";
import { useNavigate } from "react-router-dom";
import PrintOrderDetails from "../PrintOrderDetails";
import CloseIcon from "@mui/icons-material/Close";

// import Others files
import PrintOrderDetailNavigator from "../PrintOrderDetailNavigator";
import MuiModal from "../../../shares/MuiModal";
import PreOrdersShowInfoModal from "./PreOrdersShowInfoModal";

const headersList = [
  { colName: "unique_id", name: "سند" },
  { colName: "employee", name: "کارمند" },
  { colName: "created_at", name: "تاریخ ثبت سفارش" },
  { colName: "total", name: "وزن کل" },
  { colName: "details", name: "جزییات سفارش" },
  { colName: "print", name: "چاپ سفارش" },

  { colName: "remove", name: "لغو سفارش" },
];
const mobileHeadersList = [
  { colName: "unique_id", name: "سند" },
  { colName: "employee", name: "کارمند" },
  { colName: "created_at", name: "تاریخ ثبت سفارش" },
  { colName: "total", name: "وزن کل" },
];
const dataKey = ["unique_id", "employee", "created_at", "total"];

const PreOrders = (props) => {
  const [isFilterOn, setIsFilterOn] = useState(false);
  const [codeFilter, setCodeFilter] = useState(null);
  const [dateFilter, setDateFilter] = useState(null);

  const [openShowInfoModal, setOpenShowInfoModal] = useState(false);

  const { userData } = useUserData();

  const [currentOerdersList, setCurrentOerdersList] = useState({ results: [] });

  const filterList = [
    {
      type: "textField",
      label_fa: "سند",
      label_en: "code",
      state: codeFilter,
    },
    {
      type: "datePicker",
      label_fa: "تاریخ ثبت سفارش",
      label_en: "date",
      state: dateFilter,
    },
  ];

  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: 30,
    count: 0,
  });
  const navigate = useNavigate();
  const getCreateOrderApi = useFetch({
    method: "get",
    url: `User_Service/${userData.username}/get_owner_employee_pre_order`,
    params: { unique_id: fixNumbers(codeFilter), date: dateFilter },
    trigger: true,
    pagination: paginationPageInfo,
    setter: setCurrentOerdersList,
    argFunc: (res) => {
      setPaginationPageInfo({
        current: res.current,
        pageSize: res.pageSize,
        count: res.count,
        next: res.next,
        previous: res.previous,
      });
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const update_filter = (state, e) => {
    if (state == "code") setCodeFilter(e.length > 0 ? e : null);
    if (state == "date") setDateFilter(e.length > 0 ? e : null);
  };
  const filter = () => {
    if (codeFilter !== null || dateFilter !== null) {
      setIsFilterOn(true);
      getCreateOrderApi.reFetch();
    }
  };

  const reset_filter = () => {
    setCodeFilter(null);
    setDateFilter(null);
    getCreateOrderApi.reFetch();
  };

  const buttonsList = [
    {
      label: "جزییات سفارش",
      component: (it) => (
        <OrderDetails
          employeePreOrders
          selectedRow={it}
          getCreateOrderApi={getCreateOrderApi}
        />
      ),
    },
  ];
  const actionsList = [
    {
      label: "چاپ",
      component: (it) => (
        <PrintOrderDetailNavigator
          employeePreOrders
          inCurrentOrder
          selectedRow={it}
        />
      ),
    },
    {
      label: "لغو سفارش",
      component: (it) => (
        <RemoveOrder selectedRow={it} getCreateOrderApi={getCreateOrderApi} />
      ),
    },
  ];
  const onChangePage = (e, page) => {
    setPaginationPageInfo({
      ...paginationPageInfo,
      current: page,
    });
    setCurrentOerdersList({ results: [] });

    getCreateOrderApi.reFetch();
  };

  const handelPrintReport = () => {
    // navigate(`/print-new-orders/new/${codeFilter}/${dateFilter}`);
    window.open(
      `/print-pre-orders/${codeFilter}/${dateFilter}`,
      "_blank"
      // "rel=noopener noreferrer"
    );
  };
  const [status, setStatus] = useState("all");
  const [ids, setIds] = useState([]);
  const confirmPreOrdersApi = useFetch({
    method: "post",
    url: `User_Service/${userData.username}/customer_create_order_from_pre_order`,
    data: {
      status: status,
      ids: ids,
    },
    trigger: false,
    argFunc: (res) => {
      getCreateOrderApi.reFetch();
      setOpenShowInfoModal(false);
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  const handlePreOrders = () => {
    // confirmPreOrdersApi.reFetch();
    setOpenShowInfoModal(true);
  };

  const confirm_create = (status = "all") => {
    setStatus(status);
    confirmPreOrdersApi.reFetch();
  };

  const update_ids = (item_id) => {
    let before = [...ids];
    if (before.includes(item_id)) {
      setIds(before.filter((i) => i !== item_id));
    } else {
      before.push(item_id);
      setIds(before);
    }
  };

  return (
    <>
      <PanelTemplate sidebarActiveLink="pre-orders">
        <>
          <div className="panel-main-header">
            <span>پیش سفارش‌ها</span>
          </div>
          <PanelFilter
            header="فیلتر سفارش‌ها:"
            list={filterList}
            update_filter={update_filter}
            filter={filter}
            reset_filter={reset_filter}
          />
          <div className="flex justify-end">
            <MuiButton
              onClick={handlePreOrders}
              variant="outlined"
              icon={<ThumbUpOffAltIcon />}
              color="secondary"
              text="ثبت سفارش"
              margin="mr-2"
            />
            <MuiButton
              onClick={handelPrintReport}
              variant="outlined"
              icon={<PrintIcon />}
              color="primary"
              text="چاپ گزارش"
              margin="mr-2"
            />
          </div>
          <PanelTable
            header="لیست سفارش‌های ثبت‌شده:"
            headers={headersList}
            mobileHeaders={mobileHeadersList}
            data={currentOerdersList.results}
            dataKey={dataKey}
            buttons={buttonsList}
            actions={actionsList}
            icon={<AccountBalanceIcon />}
          />
          <MuiPagination
            onChange={onChangePage}
            count={Math.ceil(
              paginationPageInfo.count / paginationPageInfo.pageSize
            )}
          />

          {openShowInfoModal && (
            <MuiModal
              openModal={openShowInfoModal}
              setOpenModal={setOpenShowInfoModal}
              width="w-4/5"
            >
              <div className="close-modal-icon">
                <CloseIcon
                  onClick={() => setOpenShowInfoModal(false)}
                  fontSize="large"
                  color="secondary"
                />
              </div>
              <PreOrdersShowInfoModal
                confirm_create={confirm_create}
                update_ids={update_ids}
                ids={ids}
                data={currentOerdersList.results}
                confirmPreOrdersApi={confirmPreOrdersApi}
              />
            </MuiModal>
          )}
        </>
      </PanelTemplate>
    </>
  );
};

export default PreOrders;
